class Conditionals {

    #conditionals;

    #fields;

    #fetchUrl;

    init(form) {
        const event = new CustomEvent('ConditionalsReady', {
            detail: {
                conditionals: this,
                form: form
            }
        });
        this.#fields = {};
        form.querySelectorAll('input, textarea, select').forEach((field) => {
            this.#fields[field.name] = field;
            field.addEventListener('change', () => {
                this.onFieldChanged(field);
            });
        });
        document.dispatchEvent(event);
    }

    set fetchUrl(url) {
        this.#fetchUrl = url;
    }

    onFieldChanged(field) {
        this.applyConditions(field);
    }

    applyConditions(field) {
        const conditions = this.#conditionals[field.name] ?? [];
        conditions.forEach(condition => {
            const isCheckbox = field.type === 'checkbox'
            let result = false;
            const value = isCheckbox ? field.checked : field.value ?? '';
            switch(condition.type) {
                case 'empty':
                    result = isCheckbox ? value === false : value === '' || value === null;
                break;
                case 'notempty':
                    result = isCheckbox ? value !== false : value !== '' && value !== null;
                break;
                case 'equals':
                    result = value === condition.value;
                break;
                case 'notequals':
                    result = value !== condition.value;
                break;
                case 'contains':
                    result = condition.value.indexOf(value) >= 0;
                break;
                case 'notcontains':
                    result = condition.value.indexOf(value) === -1;
                break;
                case 'starts':
                    result = condition.value.startsWith(value);
                break;
                case 'notstarts':
                    result = condition.value.startsWith(value);
                break;
                case 'ends':
                    result = condition.value.endsWith(value);
                break;
                case 'notends':
                    result = condition.value.endsWith(value);
                break;
                case 'matches':
                case 'notmatches':
                    const expr = new RegExp(condition.value);
                    const matches = expr.test(value);
                    result = condition.type === 'matches' ?  matches: !matches;
                break;
                default:
                    throw new Error(`Invalid condition type: ${condition.type}`);
            }
            if (result) {
                condition.actions.forEach((action) => {
                    const target = this.#fields[action.target] ?? null;
                    if (target !== null) {
                        switch(action.type) {
                            case 'field_visibility':
                                // First try to resolve to the closest .block-field
                                let fieldContainer = target.closest('.block-field');
                                if (! fieldContainer ) {
                                    // Fallback to the closest <div>
                                    fieldContainer = target.closest('div');
                                } else {
                                    // Try to get a col-* parent
                                    const col = fieldContainer.closest('[class^=col-]');
                                    fieldContainer = col ? col : fieldContainer;
                                }
                                fieldContainer.classList.toggle('d-none', action.action === 'set');
                            break;
                            case 'field_required':
                                target.required = action.action === 'set';
                            break;
                            case 'field_disabled':
                                target.disabled = action.action === 'set';
                            break;
                            case 'field_value':
                                target.value = action.value ?? '';
                            break;
                            case 'field_chained':
                                const options = action.options ?? [];
                                const catalog = action.catalog ?? null;
                                if (catalog) {
                                    const state = target.disabled;
                                    target.disabled = true;
                                    fetch(this.#fetchUrl.replace('ID', catalog)).then(response => {
                                        if (response.ok) {
                                            response.json().then(data => {
                                                this.populateSelect(target, data);
                                            });
                                        } else {
                                          throw new Error(`Failed to fetch catalog data: ${response.status}`);
                                        }
                                    }).finally(() => {
                                        target.disabled = state;
                                    });
                                } else if (options) {
                                    this.populateSelect(target, options);
                                }
                            break;
                            default:
                                throw new Error(`Invalid action type: ${action.type}`);
                        }
                    } else {
                        throw new Error(`Invalid target name: ${action.target}`);
                    }
                });
            }
        });
    }

    applyAll() {
        Object.keys(this.#conditionals).forEach(name => {
            const field = this.#fields[name] ?? null;
            if (field) {
                this.applyConditions(field);
            }
        });
    }

    populateSelect(field, options) {
        const createOption = (value, label = null) => {
            const option = document.createElement('option');
            option.value = value;
            option.label = label ?? value;
            return option;
        };
        const placeholder = createOption('', field.dataset.placeholder ?? '');
        const currentValue = field.dataset.value ?? '';
        field.innerHTML = '';
        field.append(placeholder);
        options.forEach(value => {
            const option = createOption(value);
            if (value === currentValue) {
                option.selected = true;
            }
            field.appendChild(option);
        });
    }

    loadConditionals(conditionals, callback) {
        this.#conditionals = {};
        conditionals.forEach(conditional => {
            conditional.forEach(condition => {
                if ( typeof this.#conditionals[condition.field] === 'undefined' ) {
                    this.#conditionals[condition.field] = [];
                }
                this.#conditionals[condition.field].push({
                    type: condition.type,
                    value: condition.value ?? null,
                    actions: condition.actions ?? [],
                });
            });
        });
        callback(this);
    }
}

export { Conditionals };
